import { BaseClass, INode, IGroupPaddingProvider, Insets } from '@ardoq/yfiles';
import { groupBounds } from './GroupBoundsCalculator';
import {
  BLOCK_DIAGRAM_GROUP_HEADER_AFTER_EXPANDER_X,
  GROUP_PADDING,
} from '../consts';

export class GroupInsetsProvider extends BaseClass(IGroupPaddingProvider) {
  constructor(private node: INode) {
    super();
  }
  override getPadding(): Insets {
    const bounds = groupBounds(this.node);
    const headerHeight = bounds.height;
    return new Insets(
      headerHeight,
      GROUP_PADDING,
      GROUP_PADDING,
      BLOCK_DIAGRAM_GROUP_HEADER_AFTER_EXPANDER_X
    );
  }
}
